export const BRAND = {
  name: "BSA Skills Academy",
  fullName: "Bossnjomane Skills Academy",
  tagline: "Empowering Skills. Building Futures.",
  email: "info@bsaskillsacademy.co.za",
  phoneDisplay: "+27 (0)XX XXX XXXX",
  phoneNote: "Number coming soon — use WhatsApp or the form below",
  whatsappDisplay: "+27 (0)XX XXX XXXX",
  whatsappHref: "#contact",
  whatsappNote: "WhatsApp number coming soon — send us the form and we'll call you",
  address: "43 Benjamin Bennet Street, Duvhapark, Witbank 1034, Mpumalanga, South Africa",
  addressShort: "Duvhapark, Witbank, Mpumalanga",
  founded: "2017",
  founder: "Joseph Mhlongo",
};

export const SUBJECTS = [
  {
    id: "mathematics",
    name: "Mathematics Core",
    grades: "Grades 6–12",
    blurb:
      "From foundations in Grade 6 through to matric exam preparation. We rebuild understanding step by step — number work, algebra, functions, geometry and calculus — so marks follow.",
    points: ["Foundations to matric exam prep", "Step-by-step problem solving", "Past-paper practice and feedback"],
    image: "https://images.unsplash.com/photo-1509228468518-180dd4864904?q=85&w=1600&auto=format&fit=crop",
    alt: "Mathematics equations worked out on a chalkboard",
  },
  {
    id: "maths-lit",
    name: "Mathematical Literacy",
    grades: "Grades 6–12",
    blurb:
      "Practical maths for real life — finance, measurement, maps, data and probability. We focus on the everyday applications that turn Maths Lit into a strong, reliable subject.",
    points: ["Real-life, applied mathematics", "Finance, measurement and data", "Confidence with word problems"],
    image: "https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?q=85&w=1600&auto=format&fit=crop",
    alt: "Worked mathematics examples on a board",
  },
  {
    id: "science",
    name: "Science",
    grades: "Grades 9–12",
    blurb:
      "Physical Sciences support from Grade 9 onwards. Concepts are taught the practical way — demonstrations, worked examples and exam technique for physics and chemistry.",
    points: ["Physics and chemistry support", "Practical, hands-on explanations", "Exam technique and past papers"],
    image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?q=85&w=1600&auto=format&fit=crop",
    alt: "Students working together on a science experiment",
  },
  {
    id: "cad",
    name: "CAD (Computer-Aided Draughting)",
    grades: "Grades 9–12",
    blurb:
      "School-level CAD support backed by BSA's established 48-hour CAD training programme. Learners build real 2D draughting skill — drawing, editing, dimensions and engineering drawing.",
    points: ["Backed by BSA's 48-hour CAD programme", "Practical 2D draughting skills", "Project and portfolio support"],
    image: "https://images.unsplash.com/photo-1581092333203-42374bcf7d89?q=85&w=1600&auto=format&fit=crop",
    alt: "Student working with CAD software on a monitor",
  },
];

export const FAQS = [
  {
    q: "Which subjects and grades do you tutor?",
    a: "We tutor Mathematics Core and Mathematical Literacy for Grades 6 to 12, and Science and CAD (Computer-Aided Draughting) for Grades 9 to 12. Every subject is available online or in person in Witbank.",
  },
  {
    q: "Can my child learn online, or must lessons be in person?",
    a: "Both options are available for every subject. Online lessons run over video call and are available anywhere in South Africa. In-person lessons take place at 43 Benjamin Bennet Street, Duvhapark, Witbank.",
  },
  {
    q: "How much do lessons cost?",
    a: "Pricing and packages are still being finalised together with the curriculum and will be published soon. Send an enquiry or book a free consultation and we'll confirm the latest options with you directly.",
  },
  {
    q: "Who are the tutors?",
    a: "Lessons are led by tutors with the necessary experience and relevant qualifications in their subjects, within Bossnjomane Skills Academy — a training academy running since 2017, founded by Joseph Mhlongo.",
  },
  {
    q: "How big are the classes?",
    a: "We keep groups small so every learner gets personal attention. One-on-one support can also be discussed during your consultation.",
  },
  {
    q: "How do I book a lesson?",
    a: "Use the lesson booking form on this page to request a slot, or send a consultation request if you'd like to talk it through first. We confirm every booking with you personally before it is final.",
  },
  {
    q: "Do you help with exam preparation?",
    a: "Yes. Term support and matric exam preparation are part of every subject, including past-paper practice and feedback.",
  },
];
